import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import axiosConfig from 'utils/axiosConfig'
import ResponsiveLayout from 'containers/Layouts/ResponsiveLayout'
import QuestionItem from './Presentation/QuestionItem'
import { Grid, Paper, Box, Typography } from '@material-ui/core'
import { Alert } from '@material-ui/lab'

const StudentViewAttempt = (props) => {
  const attemptid = props.match.params.attempt
  const examid = props.match.params.exam

  const [exam, setExam] = useState({})
  const [attempt, setAttempt] = useState({})
  const [questions, setQuestions] = useState([])
  const [totalPoints, setTotalPoints] = useState(0)

  const getAttemptDetails = () => {
    axiosConfig.get(`student-examinations/${examid}/attempts/${attemptid}`)
      .then((response) => {
        const responseData = response.data

        if (!responseData.success) {
          console.log(responseData.message)
          return
        }

        setExam(responseData.examination)
        setQuestions(responseData.questions)
        setAttempt(responseData.attempt)
      })
  }

  useEffect(() => {
    getAttemptDetails()
  }, [])

  return (
    <ResponsiveLayout>
      <Grid lg={8} md={6} style={{margin: '0 auto'}}>
        <Paper style={{marginBottom: '20px'}}>
          <Box padding={3}>
            <Link to={`/examinations/${exam.id}/attempts`}>
              <i className="fa fa-arrow-left"></i> All Attempts
            </Link>
            <Typography variant="h6">{exam.name}</Typography>
            <Typography variant="subtitle1">{exam.description}</Typography>
            <Box paddingTop={1} display="flex" whiteSpace={2} gridGap={30} marginBottom={3}>
              <Box>
                <i className="fa fa-calendar"></i> Date Submitted: {exam.date_submitted}
              </Box>
              <Box>
                <i className="fa fa-star"></i> {attempt.verified === 0 ? 'This attempt is being reviewed. The score is still subject to change and has not been finalized yet.' : `Score: ${attempt.score}`}
              </Box>
            </Box>
            <Box>
              {attempt.verified === 1 && <Alert severity="success">This attempt is accepted. The score is recorded as your official score for this exam</Alert>}
            </Box>
          </Box>
          <Box style={{backgroundColor: 'rgba(209, 209, 209, 0.22)'}} padding={3}>
            {questions.length > 0 && questions.map((q) => (
              <QuestionItem
                key={q.id}
                question={q}
                forceReadOnly
              />
            ))}
          </Box>
        </Paper>
      </Grid>
    </ResponsiveLayout>
  )
}

export default StudentViewAttempt